@import 'styles/blaze/mixins';
@import 'styles/mixins';
@import 'styles/variables';

.tab {
  padding: 12px 10px;
  outline: none;
  max-width: 250px;
  flex: 1;
  text-align: center;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  cursor: pointer;
  min-width: 0;

  &:hover {
    background: var(--dark-5);
  }

  &.selected {
    border-radius: 8px 8px 0px 0px;
    background: var(--light-100);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);

    &:hover {
      margin-bottom: 0;
    }
  }

  &.disabled {
    cursor: not-allowed;
  }
}

@media (min-width: $phoneMaxWidth) {
  .tab {
    &.selected {
      min-width: unset;
    }
  }
}
